import React from "react";

import MejorateQuiz from "./MejorateQuiz";

const preguntasCocaina = [
  // Pregunta 1
  {
    question:
      "¿Cuál es uno de los efectos más significativos del consumo de cocaína?",
    options: [
      "La disminución de la hiperactividad",
      "El desarrollo de dependencia y/o adicción",
      "La mejora de la función respiratoria",
      "El desarrollo de una mayor capacidad de aprendizaje",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 2
  {
    question: "¿Por qué la cocaína es altamente adictiva?",
    options: [
      "Porque mejora la concentración y el aprendizaje a largo plazo",
      "Porque reduce los niveles de estrés y ansiedad",
      "Porque incrementa los niveles de serotonina en el sistema de recompensa del cerebro",
      "Porque afecta el sistema de recompensa del cerebro, aumentando los niveles de dopamina",
    ],
    correctAnswerIndex: 3,
  },
  // Pregunta 3
  {
    question:
      "¿Qué efectos cognitivos puede causar el uso prolongado de cocaína?",
    options: [
      "Mejora en la capacidad de atención y memoria",
      "Mayor rapidez en la toma de decisiones",
      "Problemas de memoria, atención y toma de decisiones",
      "Incremento en la concentración y claridad mental",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 4
  {
    question:
      "¿Qué síntomas psicológicos pueden surgir por el consumo prolongado de cocaína?",
    options: [
      "Motivación elevada y calma",
      "Paranoia, alucinaciones y ansiedad",
      "Reducción de la irritabilidad y mejora del estado de ánimo",
      "Aumento de la estabilidad emocional y reducción del estrés",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 5
  {
    question:
      "¿Cuál de los siguientes efectos es común en el estado de ánimo de quienes usan cocaína durante períodos prolongados?",
    options: [
      "Serenidad y estabilidad emocional",
      "Irritabilidad y alteraciones del estado de ánimo",
      "Incremento en la paciencia y tolerancia",
      "Mejora en la gestión del estrés y en la tranquilidad",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 6
  {
    question:
      "¿Cuál de los siguientes efectos puede producir el consumo de cocaína?",
    options: [
      "Disminución de la presión arterial y reducción del riesgo de accidentes cardiovasculares",
      "Incremento de la calma y la relajación de los vasos sanguíneos",
      "Aumento del riesgo de accidentes cerebrovasculares y convulsiones",
      "Mejora de la frecuencia cardíaca y estabilidad circulatoria",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 7
  {
    question:
      "¿Por qué el consumo de cocaína incrementa el riesgo de accidentes cerebrovasculares?",
    options: [
      "Porque reduce la presión arterial y mejora el flujo sanguíneo",
      "Por su efecto vasoconstrictor y su capacidad para aumentar la presión arterial y la frecuencia cardíaca",
      "Porque disminuye la frecuencia cardíaca y la presión arterial",
      "Porque facilita la relajación de los vasos sanguíneos",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 8
  {
    question: "¿Qué efecto tiene el consumo de cocaína sobre el cerebro?",
    options: [
      "Aumento de la materia gris y regeneración celular",
      "Aceleración del envejecimiento cerebral y reducción de la materia gris",
      "Mejora en la conectividad neuronal y crecimiento cerebral",
      "Incremento de la neuroplasticidad y regeneración de tejidos",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 9
  {
    question:
      "¿A través de qué mecanismos causa daño cerebral el consumo de cocaína?",
    options: [
      "Estimulación de la memoria y reducción de la inflamación",
      "Aumento de la neuroprotección y del flujo sanguíneo cerebral",
      "Estrés oxidativo, inflamación y neurotoxicidad",
      "Mejora en la oxigenación y fortalecimiento neuronal",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 10
  {
    question: "¿Cómo puede afectar el consumo crónico de cocaína al sueño?",
    options: [
      "Mejora su calidad y cantidad",
      "Produce alteraciones en su cantidad y calidad",
      "Aumenta la capacidad para conciliarlo rápidamente",
      "Favorece un descanso más profundo y reparador",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 11
  {
    question:
      "¿Qué efectos en el sistema cardiovascular pueden estar asociados con el consumo de cocaína?",
    options: [
      "Reducción del riesgo de enfermedades cardíacas y mejora de la frecuencia cardíaca",
      "Aumento de la resistencia cardíaca y prevención de infartos",
      "Mayor riesgo de infartos, miocardiopatía, arritmias y enfermedades cardíacas",
      "Estabilización de la presión arterial y reducción de arritmias",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 12
  {
    question:
      "¿Qué forma de cocaína está asociada con un mayor riesgo de daño respiratorio?",
    options: [
      "Cocaína inyectada",
      "Cocaína en polvo",
      "Crack",
      "Cocaína líquida",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 13  
  {
    question:
      "¿Qué puede causar el consumo de crack en el aparato respiratorio?",
    options: [
      "Mejora en la función pulmonar y reducción de infecciones respiratorias",
      "Daño pulmonar grave, incluyendo EPOC y neumonía",
      "Incremento en la capacidad pulmonar y resistencia respiratoria",
      "Protección contra enfermedades respiratorias crónicas",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 14
  {
    question:
      "¿Qué cambios pueden ocurrir en el trato gastrointestinal debido al uso de cocaína?",
    options: [
      "Mejora del flujo sanguíneo intestinal y protección contra úlceras",
      "Úlceras, perforaciones y disminución del flujo sanguíneo al intestino",
      "Aumento de la motilidad intestinal y mejor digestión",
      "Reducción del riesgo de infecciones gastrointestinales",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 15
  {
    question:
      "¿Qué efectos puede tener el consumo de cocaína sobre la salud dental?",
    options: [
      "Aumento de la producción de saliva y fortalecimiento de los dientes",
      "Bruxismo y erosión dental por disminución del pH salival",
      "Mejora en la salud de las encías y reducción de las caries",
      "Prevención de infecciones y caries dentales",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 16
  {
    question: "¿Qué puede suceder en la boca debido al uso de cocaína?",
    options: [
      "Perforación del paladar y necrosis maxilar",
      "Mejora en la estructura ósea del maxilar y fortalecimiento del paladar",
      "Aumento de la resistencia ósea y protección contra fracturas",
      "Reducción de la sensibilidad dental y fortalecimiento de los huesos maxilares",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 17
  {
    question:
      "¿Cómo aumenta el riesgo de enfermedades infecciosas en usuarios de cocaína?",
    options: [
      "Por la inhalación de cocaína y la exposición al aire",
      "Por el uso compartido de agujas al inyectarse cocaína",
      "A través de la ingestión de cocaína y sus efectos en el sistema inmunológico",
      "Por la transmisión del virus a través de la piel al tocar la cocaína",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 18
  {
    question:
      "¿Cuáles de las siguientes enfermedades es posible contraer por el uso compartido de aguja con otros consumidores?",
    options: [
      "VIH y hepatitis C",
      "Cáncer de pulmón y bronquitis crónica",
      "Enfermedades respiratorias agudas y asma",
      "Diabetes y enfermedades cardiovasculares",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 19
  {
    question:
      "¿Cómo puede afectar la dependencia de la cocaína a la vida personal?",
    options: [
      "Mejora la comunicación y fortalece los lazos familiares",
      "Puede llevar al deterioro de las relaciones personales y familiares",
      "Favorece la resolución de conflictos familiares y el fortalecimiento de las relaciones",
      "Aumenta la empatía y la comprensión en las relaciones",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 20
  {
    question:
      "¿Qué impacto puede tener la dependencia de la cocaína en el ámbito laboral?",
    options: [
      "Aumento de la productividad y el rendimiento laboral",
      "Problemas como ausentismo y disminución del rendimiento",
      "Mejora en la concentración y toma de decisiones en el trabajo",
      "Reducción de la carga de trabajo y mejor desempeño profesional",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 21
  {
    question:
      "¿Qué tipo de consecuencias legales pueden surgir debido al consumo de cocaína?",
    options: [
      "Problemas relacionados con la posesión y distribución de drogas",
      "Multas por no reciclar correctamente",
      "Sanciones por no pagar el impuesto de circulación",
      "Infracciones por no respetar la zona azul de aparcamiento",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 22
  {
    question:
      "¿Cómo puede afectar el consumo de cocaína a la situación económica de una persona?",
    options: [
      "Causando dificultades económicas debido al costo de mantener la adicción",
      "Aumentando el ahorro personal gracias a la reducción de gastos",
      "Mejorando la estabilidad financiera por el aumento de la productividad",
      "Facilitando el acceso a créditos y préstamos debido a la mejora del rendimiento laboral",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 23
  {
    question:
      "¿Qué trastornos pueden desarrollarse o empeorar debido al uso crónico de cocaína?",
    options: [
      "Depresión, ansiedad y trastornos psicóticos",
      "Trastorno de la memoria relacionados con el consumo de cafeína",
      "Síndrome de Tourette",
      "Trastorno de la conductividad eléctrica del corazón",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 24
  {
    question:
      "¿Qué efectos físicos pueden resultar del abuso prolongado de cocaína?",
    options: [
      "Aumento de peso y retención de líquidos",
      "Pérdida de peso y deterioro general",
      "Mejora de la salud cardiovascular y aumento de la energía",
      "Crecimiento acelerado del cabello y fortalecimiento muscular",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 25
  {
    question:
      "¿Qué problemas pueden aparecer debido al abuso prolongado de cocaína?",
    options: [
      "Deterioro dental y problemas de piel",
      "Aumento de la elasticidad de la piel y dientes más fuertes",
      "Mejora de la salud de las encías y reducción de la caries dental",
      "Incremento en la hidratación de la piel y fortalecimiento de los dientes",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 26
  {
    question:
      "¿Qué factores aumentan significativamente el riesgo de efectos adversos al consumir cocaína?",
    options: [
      "La frecuencia de ejercicio físico y la dieta",
      "La ocupación y el nivel educativo",
      "El nivel y la duración del consumo",
      "La cantidad de horas de sueño y la exposición al sol",
    ],
    correctAnswerIndex: 2,
  },
];

export default function MejorateCocaina() {
  return <MejorateQuiz quizType="Cocaína" questions={preguntasCocaina} />;
}
